import { CheckCircle2, RotateCcw, Copy } from "lucide-react";
import { toast } from "sonner";

export default function Success({ referenceNumber, onReset }) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(referenceNumber);
      toast.success("Reference number copied");
    } catch {
      toast.error("Could not copy. Please copy manually.");
    }
  };

  return (
    <div className="text-center py-6" data-testid="wizard-step-success">
      <div className="mx-auto mb-6 w-20 h-20 rounded-full accent-soft-bg flex items-center justify-center">
        <CheckCircle2 size={44} className="accent-text" strokeWidth={1.8} />
      </div>
      <h2 className="text-3xl sm:text-4xl font-medium tracking-tight mb-3">
        Submission Received
      </h2>
      <p className="text-secondary-brand max-w-md mx-auto leading-relaxed mb-8">
        Thank you. Your details have been securely captured. Our team will get
        in touch shortly.
      </p>

      <div className="inline-flex items-center gap-3 bg-surface border border-subtle rounded-2xl px-5 py-4 mb-8">
        <div className="text-left">
          <p className="text-xs uppercase tracking-widest text-muted-brand">
            Reference Number
          </p>
          <p
            className="text-lg font-semibold tracking-wide"
            data-testid="reference-number"
          >
            {referenceNumber}
          </p>
        </div>
        <button
          type="button"
          onClick={copy}
          className="ml-3 p-2 rounded-lg hover:bg-base transition-colors"
          data-testid="copy-reference"
          aria-label="Copy reference number"
        >
          <Copy size={18} className="text-secondary-brand" />
        </button>
      </div>

      <div>
        <button
          type="button"
          onClick={onReset}
          className="btn-secondary"
          data-testid="restart-button"
        >
          <RotateCcw size={16} />
          Start a new submission
        </button>
      </div>
    </div>
  );
}
